<ng-template #getStartedButtonTemplate>
	<div libFlexRow [libFlexRowAlign]="'center'">
		<div libFlexColumn libFlexFill>
			<lib-button [routerLink]="getStartedUrl()" [buttonSize]="'full'" [buttonType]="'primary'"
				>Get Started</lib-button
			>
		</div>
	</div>
</ng-template>

<ng-template #tryForFreeButtonTemplate>
	<div libFlexRow [libFlexRowAlign]="'center'">
		<div libFlexColumn [libFlexSize]="undefined">
			<lib-link [routerLink]="signupRouterLink()"
				><button class="w-home-get-started-button">Try {{ originalAppName() }} for free</button></lib-link
			>
		</div>
	</div>
</ng-template>

@if (showLoginInsteadOfHome()) {
<mod-login></mod-login>
} @else {

<app-layout-main [pageMetadata]="{ title: originalAppName() }" [design]="'home'">
	<div [class.mobile]="isMobileView()">
		@if (appSetup(); as appSetup) {
		<div class="w-home-section teaser" [class.light]="theme() === 'light'" [class.dark]="theme() === 'dark'">
			<div class="w-section-content" [ngStyle]="layoutSizeStyles()">
				<div class="w-text-center">
					<h1>{{ appSetup.mainTitle }}</h1>
					<h2>
						{{ appSetup.mainSubtitle }}
					</h2>
				</div>

				<div class="push-top-xxl">
					<ng-template [ngTemplateOutlet]="tryForFreeButtonTemplate"></ng-template>
				</div>

				@if (isMobileView()) {
				<div [libFlexRow]="false" [libFlexRowAlign]="'center'" class="push-top-xl">
					<div libFlexColumn>
						<lib-image
							[alt]="'App teaser image'"
							[isRound]="false"
							[isResponsive]="true"
							[imageSize]="'original'"
							[maxHeight]="600"
							[boxShadow]="'default'"
							[image]="mobileTeaserImage()"
							[priority]="true"
						></lib-image>
					</div>
				</div>
				} @else {
				<div [libFlexRow]="false" [libFlexRowAlign]="'center'" class="push-top-xl">
					<div libFlexColumn [style.max-width]="'650px'">
						<lib-image
							[alt]="'Desktop teaser'"
							[isRound]="false"
							[isResponsive]="true"
							[imageSize]="'original'"
							[maxHeight]="600"
							[boxShadow]="'default'"
							[image]="desktopTeaserImage()"
							[priority]="true"
						></lib-image>
					</div>
					<div libFlexColumn [style.max-width]="'350px'">
						<lib-image
							[alt]="'Mobile teaser'"
							[isRound]="false"
							[isResponsive]="true"
							[imageSize]="'original'"
							[maxHeight]="600"
							[boxShadow]="'default'"
							[image]="mobileTeaserImage()"
							[priority]="true"
						></lib-image>
					</div>
				</div>
				}
			</div>
		</div>

		<div [id]="anchors.pricing" class="w-anchor"></div>
		<div class="w-home-section centered">
			<div class="w-section-content" [ngStyle]="layoutSizeStyles()">
				<div>
					<h3>Unlimited Clients</h3>
					<div class="w-section-subtitle">
						One transparent, straightforward price for everything you need.
					</div>
				</div>
				<div class="push-top">
					<div libFlexRow>
						@if (!isMobileView()) {
						<div libFlexColumn libFlexFill></div>
						}
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : '350px'">
							<lib-card [removePadding]="true">
								<div class="w-price-card">
									<div libPad>
										<div class="w-price-wrapper">
											<span class="w-price">
												{{ pricing() }}
											</span>
											<span class="w-price-month">/ month</span>
										</div>
										<div class="w-price-features">
											@for (feature of featureList; track feature; let first = $first; let index =
											$index) {
											<div libFlexRow [libFlexRowGap]="'16px'" class="w-price-feature push-top">
												<div libFlexColumn>
													<lib-icon [color]="'success'" [type]="'check'"></lib-icon>
												</div>
												<div
													libFlexColumn
													[class.highlighted]="index <= highlightFeaturesIndex"
												>
													{{ feature }}
												</div>
											</div>
											}
										</div>

										<div class="push-top-xl">
											<ng-template [ngTemplateOutlet]="getStartedButtonTemplate"></ng-template>
										</div>
									</div>
								</div>
							</lib-card>
						</div>
						@if (!isMobileView()) {
						<div libFlexColumn libFlexFill></div>
						}
					</div>
				</div>
			</div>
		</div>

		@if (displayFeatures()) {
		<div [id]="anchors.features" class="w-anchor"></div>
		<div class="w-home-section alt centered">
			<div class="w-section-content-horizontal" [ngStyle]="layoutFeaturesSizeStyles()">
				<div class="w-features">
					<ng-container>
						@for(feature of features(); track feature.id; let first = $first) {
						<div
							[libFlexRow]="isMobileView()"
							[libFlexRowAlign]="'center'"
							class="w-feature-wrapper"
							[class.light]="theme() === 'light'"
							[class.dark]="theme() === 'dark'"
							[class.push-top-xl]="!first"
							[class.w-section-content-vertical]="!feature.isAlt"
							[class.alt]="feature.isAlt"
						>
							<div
								libFlexColumn
								[libFlexSize]="'400px'"
								[class.w-column-reverse]="feature.isAlt && !isMobileView()"
							>
								<div>
									<div libPad [class.push-top]="!first">
										<div [libFlexRow]="false" [libFlexRowGap]="'24px'">
											<div libFlexColumn libFlexFill>
												<h3>
													{{ feature.title }}
												</h3>
												<div class="w-feature-description push-top-md">
													{{ feature.text }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							@if (isMobileView()) {
							<div libFlexColumn [libFlexSize]="'full'">
								@if (feature.image) {
								<lib-image
									[alt]="feature.title"
									[isRound]="false"
									[isResponsive]="true"
									[boxShadow]="'default'"
									[imageSize]="'original'"
									[image]="feature.image"
								></lib-image>
								}
							</div>
							} @else {
							<div libFlexColumn>
								@if (feature.image) {
								<lib-image
									[alt]="feature.title"
									[isRound]="false"
									[isResponsive]="true"
									[boxShadow]="'default'"
									[imageSize]="'original'"
									[image]="feature.image"
									[maxWidth]="700"
									[maxHeight]="400"
								></lib-image>
								}
							</div>
							}
						</div>
						}
					</ng-container>
				</div>
			</div>
		</div>
		}

		<div [id]="anchors.contact" class="w-anchor"></div>
		<div class="w-home-section centered">
			<div class="w-section-content" [ngStyle]="layoutSizeStyles()">
				<h3>Contact</h3>
				<div class="w-section-subtitle">We'll be happy to answer your questions</div>

				<div class="push-top-md w-contact-form" libFlexRow>
					@if (!isMobileView()) {
					<div libFlexColumn libFlexFill></div>
					}
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : '50'">
						<mod-contact-form [enableCard]="true"></mod-contact-form>
					</div>
					@if (!isMobileView()) {
					<div libFlexColumn libFlexFill></div>
					}
				</div>

				<div class="push-top-xl">
					<ng-template [ngTemplateOutlet]="tryForFreeButtonTemplate"></ng-template>
				</div>
			</div>
		</div>

		<div [id]="anchors.app" class="w-anchor"></div>
		<div class="w-home-section alt centered">
			<div class="w-section-content" [ngStyle]="layoutSizeStyles()">
				<h3>Get App</h3>
				<div class="w-section-subtitle">
					Train smarter, anywhere - {{ originalAppName() }} is ready for your tablet or phone.
				</div>
				<div class="push-top-md">
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
							<div>
								<mod-install-button></mod-install-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div [id]="anchors.faqs" class="w-anchor"></div>
		<div class="w-home-section centered">
			<div class="w-section-content" [ngStyle]="layoutSizeStyles()">
				<h3>Frequently Asked Questions</h3>
				<div class="push-top-xl w-faqs">
					<div [libFlexRow]="true" [libFlexRowGap]="'24px'" [libFlexRowAlign]="'start'">
						@for (faq of faqs; track faq.title) {
						<div libFlexColumn [style.width]="calculateFlexWidth(isMobileView() ? 1 : 2, 24)">
							<div>
								<h4>
									{{ faq.title }}
								</h4>
							</div>
							<div libText1 class="push-top-xs w-faq-text">
								{{ faq.text }}
							</div>
						</div>
						}
					</div>
				</div>
			</div>
		</div>
		}
	</div>
</app-layout-main>

}
